import React from 'react';
import { useTranslation } from 'react-i18next';
import ServicePageLayout from '../../component/common/servicesPagesLayout';

const CloudPage = () => {
  const { t } = useTranslation();

  const features = [
    {
      icon: '☁️',
      title: t('cloud.features.1.title'),
      description: t('cloud.features.1.desc'),
    },
    {
      icon: '🚀',
      title: t('cloud.features.2.title'),
      description: t('cloud.features.2.desc'),
    },
    {
      icon: '💾',
      title: t('cloud.features.3.title'),
      description: t('cloud.features.3.desc'),
    },
    {
      icon: '🗄️',
      title: t('cloud.features.4.title'),
      description: t('cloud.features.4.desc'),
    },
    {
      icon: '🔄',
      title: t('cloud.features.5.title'),
      description: t('cloud.features.5.desc'),
    },
    {
      icon: '🔒',
      title: t('cloud.features.6.title'),
      description: t('cloud.features.6.desc'),
    },
  ];

  const process = [
    { title: t('cloud.process.1.title'), description: t('cloud.process.1.desc') },
    { title: t('cloud.process.2.title'), description: t('cloud.process.2.desc') },
    { title: t('cloud.process.3.title'), description: t('cloud.process.3.desc') },
    { title: t('cloud.process.4.title'), description: t('cloud.process.4.desc') },
  ];

  const whyChooseUs = [
    { stat: '30%', label: t('cloud.why.1.label') },
    { stat: '99.9%', label: t('cloud.why.2.label') },
    { stat: '3+', label: t('cloud.why.3.label') },
    { stat: '24/7', label: t('cloud.why.4.label') },
  ];

  const techStack = [
    { icon: '🔶', name: 'AWS' },
    { icon: '☁️', name: 'Google Cloud' },
    { icon: '🔵', name: 'Azure' },
    { icon: '🐳', name: 'Docker' },
    { icon: '☸️', name: 'Kubernetes' },
    { icon: '📦', name: 'Terraform' },
    { icon: '🔀', name: 'Jenkins' },
    { icon: '🐙', name: 'GitHub Actions' },
    { icon: '📊', name: 'Grafana' },
    { icon: '🌊', name: 'DigitalOcean' },
  ];

  const faqs = [
    {
      question: t('cloud.faq.q1'),
      answer: t('cloud.faq.a1'),
    },
    {
      question: t('cloud.faq.q2'),
      answer: t('cloud.faq.a2'),
    },
    {
      question: t('cloud.faq.q3'),
      answer: t('cloud.faq.a3'),
    },
  ];

  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Cloud Services',
    provider: {
      '@type': 'Organization',
      name: 'BringIt Go',
      url: 'https://www.bringitgo.tech',
    },
    description: 'Cloud infrastructure setup, application migration, DevOps, and managed cloud services on AWS, Google Cloud, and Azure.',
    url: 'https://www.bringitgo.tech/cloud',
    areaServed: 'Worldwide',
    serviceType: 'Cloud Services',
  };

  const faqStructuredData = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <ServicePageLayout
      accentClass="service-accent-cloud"
      badge={t('cloud.badge')}
      title={t('cloud.heroTitle')}
      description={t('cloud.heroDescription')}
      features={features}
      process={process}
      whyChooseUs={whyChooseUs}
      techStack={techStack}
      faqs={faqs}
      seo={{
        title: t('cloud.seo.title'),
        description: t('cloud.seo.description'),
        canonical: 'https://www.bringitgo.tech/cloud',
      }}
      structuredData={[structuredData, faqStructuredData]}
    />
  );
};

export default CloudPage;
